import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-quiz-progress-header',
  templateUrl: './quiz-progress-header.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizProgressHeaderComponent {
  readonly percent = input.required<number>();
  readonly stepLabel = input<string>('');
  readonly closed = output<void>();

  onCloseClick(): void {
    this.closed.emit();
  }

  /** Keyboard activation for the div-as-button close control (Enter/Space). */
  onCloseKeydown(event: Event): void {
    event.preventDefault();
    this.onCloseClick();
  }
}
